import { render, staticRenderFns } from "./BuyerDeliveryAddressList.component.vue?vue&type=template&id=aa15a254&scoped=true&"
import script from "./BuyerDeliveryAddressList.component.vue?vue&type=script&lang=js&"
export * from "./BuyerDeliveryAddressList.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa15a254",
  null
  
)

export default component.exports